function AdvanceDepositReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">AdvanceDepositReport</div>
      </>
    );
  }
  
  export default AdvanceDepositReport;